import {DELETE_DEFAULT,GET_DEFAULT,PUT_DEFAULT,POST_DEFAULT,API_ROOT,GET_TOKEN} from './index.js';

const HOST=API_ROOT;

export function LOGIN(params={mobile:''}){
  return POST_DEFAULT(`${HOST}/user`,params);
}

export function GET_RANDOM_WISH(){
  return GET_DEFAULT(`${HOST}/wishes`);
}

export function HELP_WISH(params={
  wish_id:''
}){
  return POST_DEFAULT(`${HOST}/user_wishes?api_token=${GET_TOKEN()}`,params,'POST',{noInterceptors:true});
}

export function GET_MY_WISHES(){
  return GET_DEFAULT(`${HOST}/user_wishes?api_token=${GET_TOKEN()}`);
}

export function EDIT_ORDER(user_wish_id,params={
  express_number:'',
  express_company:''
}){
  return PUT_DEFAULT(`${HOST}/user_wishes/${user_wish_id}?api_token=${GET_TOKEN()}`,params)
}

export function GET_COMPLETE_COUNT(){
  return GET_DEFAULT(`${HOST}/user_wishes_count?api_token=${GET_TOKEN()}`);
}


export function DEL_WISH(id){
  return DELETE_DEFAULT(`${HOST}/user_wishes/${id}/?api_token=${GET_TOKEN()}`);
}

